var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GoogleMapMarker',{attrs:{"google":_vm.google,"map":_vm.map,"options":_vm.options,"removeOldMarkers":_vm.removeOldMarkers},on:{"drag":_vm.handleMarker}})}
var staticRenderFns = []

export { render, staticRenderFns }